'use client'

import { useEffect, useState } from 'react'

import { cn } from '../../../../lib/utils'

interface Props {
  logoSrc?: string
  logoSize?: 'default' | 'small'
  name: string
}

// Accepts both Company and / or Venue information
function ProviderInformation({ logoSrc, logoSize = 'default', name }: Props) {
  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setHasScrolled(window.scrollY !== 0)
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className="relative flex h-full flex-1 items-center gap-4">
      {logoSrc && (
        <div
          className={cn(
            'relative mt-4 hidden origin-top-left self-start sm:block sm:transition-transform sm:duration-500 sm:ease-in-out',
            hasScrolled && 'absolute mt-2 scale-[0.4]',
            logoSize === 'default' ? 'size-28' : 'size-20',
          )}
        >
          <img
            src={logoSrc}
            alt=""
            className={cn(
              'z-10 rounded-lg border border-border-divider bg-white object-cover shadow',
              logoSize === 'default' ? 'size-28' : 'size-20',
            )}
            width={logoSize === 'default' ? 112 : 80}
            height={logoSize === 'default' ? 112 : 80}
          />
        </div>
      )}
      <div
        className={cn(
          'line-clamp-1 text-lg font-semibold sm:absolute sm:left-32 sm:transition-all sm:duration-500 sm:ease-in-out',
          logoSize === 'default' ? 'sm:left-32' : 'sm:left-24',
          hasScrolled && 'sm:left-[60px]',
          !logoSrc && 'left-0 sm:left-0',
        )}
      >
        {name}
      </div>
    </div>
  )
}

export { ProviderInformation }
